import loadable from "@loadable/component";

export const AddEditSubscriptionForm = loadable(() =>
  import("./EditSubscriptionForm/index.form"),
);
